module.exports = {
id:151,
title: 'What We\'re Doing Tomorrow',
date: '2026-04-13',
content: `<p>Negotiations between LAUSD and SEIU have not yet led to an agreement, and apparently mayor Karen Bass is now at the bargaining table&ndash;we need a POWERFUL showing tomorrow to push LAUSD to make a deal.&nbsp;</p>
<p>Our support is strong&ndash;123 Monroe teachers have signed the pledge to strike and to be on the picket line.</p>
<h2>Tomorrow&ndash;What You Need to Do</h2>
<p>Meet on Haskell at 7 AM or as early as you can. You will then:</p>
<ul>
<li>Do the member strike sign-in&ndash;we will have it available for you at the sign-in table.</li>
<li>Begin picketing</li>
</ul>
<p>We will have coffee, drinks, food, and music. <strong>Wear red!</strong> Feel free to bring your children.</p>
<p>After morning picketing we will go to the Citywide rally at Grand Park&ndash;see full schedule below.</p>
<h2>Itinerants, Substitutes, Parents, Students &amp; Community Members&hellip;</h2>
<p>&hellip;we want all of you with us&ndash;please come to the sign-in table upon arrival.</p>
<h2>Tomorrow&rsquo;s Strike Schedule</h2>
<table>
<tbody>
<tr>
<td colspan="2">
Day: Tuesday, 4/14/26
</td>
</tr>
<tr>
<td>
Earlybird Arrival for Setup&ndash;your help would be appreciated
</td>
<td>
<p>6:30-7:00 AM</p>
</td>
</tr>
<tr>
<td>
School Site Picketing
</td>
<td>
7:00-9:00 AM
</td>
</tr>
<tr>
<td>
Daily Monroe Huddle and Check-in
</td>
<td>
9:00-9:30 AM
</td>
</tr>
<tr>
<td>
Citywide rally at Grand Park (200 N. Spring Street, Los Angeles)
</td>
<td>
10:30-1:30 PM
</td>
</tr>
<tr>
<td>
Assuming schools are closed, our day ends at 1:30 pm.
</td>
<td>
</td>
</tr>
</tbody>
</table>
<h2>What You&rsquo;ll Be Doing</h2>
<p>Picket lines will be set up to cover all entrances as well as the most visible locations around the school. Expect to be moving and chanting. We will have music.</p>
<h2>Please Remember to&hellip;</h2>
<ul>
<li>Remain peaceful, calm, and orderly at all times. </li>
<li>Don&rsquo;t block parents or children arriving at the food distribution center</li>
<li>Don&rsquo;t argue with parents or community members.&nbsp;</li>
<li>Don&rsquo;t argue with police. If there is an issue, please let me know.</li>
</ul>
<p>If anybody has any questions, please text or call me at (818) 470-8587.<p>

<h2>Monroe Alumni Support Us: Leobardo Hernandez&rsquo;s Daughter X&oacute;chitl</h2>
<p>X&oacute;chitl Hern&aacute;ndez was with us on our picket lines in 2019 and will be on our picket lines tomorrow. She is subbing in LAUSD right now. When offered subbing gigs for this week, she said, &ldquo;No way I&rsquo;m crossing a picket line&ndash;I&rsquo;ll be out there with UTLA.&rdquo;</p>
<h2>Monroe Alumni Support Us: Maximilien Jimenez, Class of 2019</h2>
<p>Maximilien Jimenez was on our picket lines in 2019, went to the rallies downtown, and was even interviewed and quoted in the <em>Washington Post. </em>He has a master&rsquo;s degree in Postsecondary Higher Education and bachelor&rsquo;s degree in Political Science, has been accepted into a Masters program in Entrepreneurship at Syracuse University, and is currently a coordinator at a private university in the northeast where he works with students who are from marginalized backgrounds.</p>
<p>Max sent in a statement of support this morning. It reads:</p>
<blockquote>
<p>&ldquo;I&rsquo;m proud to stand in support of the educators and staff who plan to strike tomorrow morning. As someone who is a product of an LAUSD school, a product of the teachers who poured skills and confidence into me as a budding scholar, I stand firmly with the members of UTLA, SEIU, and AALA.</p>
<p>&ldquo;I witnessed Monroe teachers bend over backwards for my success and for my friends' success--this experience is why I&rsquo;m an educator today. I remember as a senior at Monroe in 2019, I stood on the sidewalk in the rain, right outside the campus gates with a passion to advocate and to support my teachers - today I stand with the same passion in support for my entire school. This isn&rsquo;t just about giving teachers a raise, this is about respecting the work that they do, building the next generation of policy makers, educators and medical health professionals. This is about respecting some of the only individuals who genuinely wanted mine and my community&rsquo;s success and who continuously go above and beyond for individuals like me.</p>
<p>"I stand with my community until we get what we deserve.&rdquo;</p>
</blockquote>
<h2>Flashback: Student Support of UTLA in 2019&hellip;</h2>
<p>While searching for something I stumbled upon the following in <em>Monroe UTLA Update #25 (1/14/19)</em>:</p>
<blockquote>
<p>&ldquo;Students who manned our picketlines today included:</p>
<p>Citlalli Castellanos; Ricky Garcia; Nestor Ar&eacute;valo; Raquel Deleon; Dennis Gonzalez; Cindy Ruiz; Heather Villase&ntilde;or; Oscar Letona; Daniel Mora; Michael Trujillo; Allison Lopez; Nadalyn Chimil; Moises Banales; Jessica Diaz; Miguel Rolon; Liliana Huitzil; Eliver Menjivar; Cristina Arechiga; Alliyah Melendez; Stephanie Viana; Chaka Tellem; Warren Lim; Daniela Lom&eacute;l; Genevieve Langdon; Andy Sanchez; George Guzman; Jesus Hernandez; Davin Huerta; Sonia Rodriguez; Alyssa Gutierrez; Roy Avita; Alex Quintero; Jose Juarez; Salma Gouda; Alex Garza; Audrey Torres; Leila de Los Reyes; Ally Lorenzo; Ally Cervas; Johanna Soto; Diego Olvera; Carlos Leyva; G&eacute;nesis P&eacute;rez; Maximiliano Jim&eacute;nez; Matthew Ramos; Mikey Rodriguez; Kimberly Diaz; Brandon Diaz; Priscila Diaz; Michelle Cruz; Elmer Cordero; Elizabeth Lopez; X&oacute;chitl Hern&aacute;ndez; Itzel Hernandez; and many others.&rdquo;</p>
</blockquote>
<p>Leo Hernandez is understandably proud that both of his daughters were out there with us in 2019.</p>
<p>To learn more about what we won in the new tentative agreement, see <a href="https://docs.google.com/document/d/10uBFZvmrxuhEEUruTMjqRMDKpLzzszb4g6l3Vrce42k/edit?usp=sharing">Monroe UTLA Update #150 (04 12 26): What We Won, Where We Stand</a>. See all of you tomorrow.</p>`
}